import Vue from 'vue'
import Router from 'vue-router'
import msal from '../msal'
import msalConfig from '../msal/config'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/portal/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/login/index.vue')
    },
    {
      path: '/chat',
      name: 'Chat',
      component: () => import('../views/chat/index.vue'),
      meta: { auth: true }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('../views/dashboard/index.vue'),
      meta: { auth: true }
    },
    // Portal routes
    {
      path: '/portal/login',
      name: 'PortalLogin',
      component: () => import('../views/portal/login/index.vue')
    },
    {
      path: '/portal',
      component: () => import('../views/portal/layout/PortalLayout.vue'),
      meta: { portalAuth: true },
      children: [
        {
          path: '',
          name: 'PortalDashboard',
          component: () => import('../views/portal/dashboard/index.vue')
        },
        {
          path: 'agents',
          name: 'PortalAgents',
          component: () => import('../views/portal/agents/index.vue')
        },
        {
          path: 'tools',
          name: 'PortalTools',
          component: () => import('../views/portal/tools/index.vue')
        },
        {
          path: 'knowledge',
          name: 'PortalKnowledge',
          component: () => import('../views/portal/knowledge/index.vue')
        },
        {
          path: 'pipelines',
          name: 'PortalPipelines',
          component: () => import('../views/portal/pipelines/index.vue')
        },
        {
          path: 'tokens',
          name: 'PortalTokens',
          component: () => import('../views/portal/tokens/index.vue')
        },
        {
          path: 'chat',
          name: 'PortalChat',
          component: () => import('../views/portal/chat/index.vue')
        },
        {
          path: 'logs',
          name: 'PortalLogs',
          component: () => import('../views/portal/logs/index.vue')
        }
      ]
    }
  ]
})

// Auth guard — MSAL SSO: if user is already logged in via Azure AD, skip login
router.beforeEach(async (to, from, next) => {
  if (to.meta.auth) {
    const token = localStorage.getItem('ai_jwt_token')
    if (!token) return next({ path: '/login' })
  }
  if (to.meta.portalAuth || (to.matched && to.matched.some(r => r.meta.portalAuth))) {
    // Option 1: Local JWT token
    var localToken = localStorage.getItem('portal_local_token')
    if (localToken) {
      return next()
    }

    // Option 2: Try MSAL silent auth (SSO from LMS or other apps on same tenant)
    const username = localStorage.getItem('portal_msal_username')
    const accounts = msal.getAllAccounts()
    const account = username
      ? accounts.find(a => a.username === username)
      : accounts[0]

    if (account) {
      try {
        await msal.acquireTokenSilent({ scopes: msalConfig.scopes, account })
        // Token valid — allow access
        localStorage.setItem('portal_msal_username', account.username)
        return next()
      } catch (e) {
        // Silent failed — clear and go to login
        localStorage.removeItem('portal_msal_username')
      }
    }

    // Fallback: no auth → go to login
    return next({ path: '/portal/login' })
  }
  next()
})

export default router
